import { StartExercise, UpdateObjective } from "Phaser/EventBus";
import { Exercise, Lecture, Tutorial, Section, Event, StaffExercise } from "Utils/TutorialConfigHelper";
import { AddEventsAndMergeTimestamps, Timestamps } from "Utils/ChaptersToTimestamps";
import timestamps from "./level14.json";

const Level14 = Tutorial(14,
  '1:14',
  [
    Section([
      Lecture('2/4 Time', '0:0'),
      Exercise('2/4 Time', '0:29',
        StaffExercise({
          objectives: [
            {
            },
            {
            },
          ]
        }),
        [
        ]
      ),
    ]),
    Section([
      Lecture('Hands Together', '0:43'),
      Exercise('Hands Together', '1:02',
        StaffExercise({
          objectives: [
            {
            },
            {
            },
          ]
        }),
        [
        ]
      )
    ]),
  ]
);

export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level14);
